/**
 * `/signIn?nyLank=1` opens "Glömt lösenord?" with an empty email: where the
 * set-password page sends someone whose link has expired. It carries no email,
 * since the expired link no longer tells us whose it was.
 */
export const NEW_LINK_PARAM = 'nyLank';

